/** Text measurement with a small cache (canvas measureText is not free). */
import { fontString } from './style.ts';

export interface Measurer {
  width(text: string, weight: number, size: number, italic?: boolean): number;
}

export function createMeasurer(ctx: CanvasRenderingContext2D): Measurer {
  const cache = new Map<string, number>();
  return {
    width(text, weight, size, italic = false) {
      const key = `${weight}${italic ? 'i' : ''}|${size.toFixed(2)}|${text}`;
      let w = cache.get(key);
      if (w === undefined) {
        ctx.font = fontString(weight, size, italic);
        w = ctx.measureText(text).width;
        if (cache.size > 4000) cache.clear();
        cache.set(key, w);
      }
      return w;
    },
  };
}

let shared: Measurer | null = null;
/** A measurer backed by a private scratch canvas. */
export function sharedMeasurer(): Measurer {
  if (!shared) {
    const c = document.createElement('canvas');
    c.width = 8;
    c.height = 8;
    shared = createMeasurer(c.getContext('2d')!);
  }
  return shared;
}
